import useSWRMutation from "swr/mutation";
import { Network } from "@/utils/network";
import type { InstagramSearch } from "../types";
import { useInstagramSearch } from "./useInstagramSearch";
import { useInstagramSearchLists } from "./useInstagramSearchLists";

interface InstagramSearchListDeleteProps {
  arg: InstagramSearch.List;
}

export const useInstagramSearchListDelete = () => {
  const config = useInstagramSearch((state) => state.config);
  const { mutate } = useInstagramSearchLists();

  return useSWRMutation(
    config.api.deleteList,
    async (api, { arg: list }: InstagramSearchListDeleteProps) => {
      await Network.post<InstagramSearch.List>(api, {
        id: list.id,
      });

      return list;
    },
    {
      onSuccess: ({ id }) => {
        mutate((data) => {
          if (data !== undefined) {
            return {
              ...data,
              lists: data.lists.filter((list) => list.id !== id),
            };
          }

          return undefined;
        }, false);
      },
    },
  );
};
